export const setParam = (params: {
  searchParams: URLSearchParams | null
  param: string
  value: string | number
}) => {
  if (!params.searchParams) return `?${params.param}=${params.value}`

  const values = Array.from(params.searchParams.entries())
  if (!params.searchParams.get(params.param))
    values.push([params.param, String(params.value)])

  const paramString = values
    .map(([key, value]) =>
      key === params.param
        ? `${params.param}=${params.value}`
        : `${key}=${value}`,
    )
    .join('&')

  return `?${paramString}`
}

export const deleteParam = (params: {
  searchParams: URLSearchParams | null
  param: string
}) => {
  if (!params.searchParams) return ''

  const values = Array.from(params.searchParams.entries())

  const paramString = values
    .filter(([key]) => key !== params.param)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `?${paramString}`
}
